// One plain sentence about a metric result, made from the figures (never from model text).
// A copy of supabase/functions/performance/lib/summary.ts (Edge Functions deploy one folder each); a test checks the
// two agree.
/** The parts of a metric result the sentence uses (crm_metric_query's reply). */
export interface SummaryInput {
  label: string;
  unit: string;
  currency: string;
  by: string;
  from: string;
  to: string;
  total: number | null;
  rows: { key?: string | null; label: string; value: number | null }[];
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS[m - 1]} ${y}`;
}

export function formatValue(v: number | null | undefined, unit: string, currency = "GBP"): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "no figure";
  if (unit === "percent") return `${Number(v).toFixed(1)}%`;
  if (unit === "money") {
    const sym = currency === "GBP" ? "£" : currency === "EUR" ? "€" : currency === "USD" ? "$" : `${currency} `;
    return `${sym}${Math.round(v).toLocaleString("en-GB")}`;
  }
  return Math.round(v).toLocaleString("en-GB");
}

export function summarise(r: SummaryInput): string {
  const range = `${formatDate(r.from)} to ${formatDate(r.to)}`;
  const total = formatValue(r.total, r.unit, r.currency);
  let s = `${r.label}, ${range}: ${total}${r.unit === "percent" ? " overall" : " in all"}.`;
  const rows = r.rows.filter((x) => x.value !== null && x.value !== undefined);
  if (["pool", "channel", "module", "route", "audience"].includes(r.by) && rows.length > 1) {
    const top = rows.reduce((a, b) => ((b.value as number) > (a.value as number) ? b : a));
    if ((top.value as number) > 0) s += ` ${top.label} was highest, at ${formatValue(top.value, r.unit, r.currency)}.`;
  }
  if ((r.by === "week" || r.by === "month") && rows.length > 1) {
    const first = rows[0]!;
    const last = rows[rows.length - 1]!;
    s += ` ${first.label}: ${formatValue(first.value, r.unit, r.currency)}; ${last.label}: ${formatValue(last.value, r.unit, r.currency)}.`;
  }
  return s;
}
